import eventPool from '../eventAffordances.json';

const dot = (v1, v2) => {
  const keys = Object.keys(v1);
  return keys.reduce((sum, key) => sum + (v1[key] || 0) * (v2[key] || 0), 0);
};

const computeDesiredCoherence = (gradientVector) => {
  const desired = {};
  gradientVector.forEach(axis => {
    desired[axis.id] = axis.gradient;
  });
  return desired;
};

const pressureWeight = (pressure) => {
  return 1 + pressure * 2;
};

const THRESHOLD = 0.1;

const biasFromCM = (eventDomains, coherenceMemory) => {
  if (!eventDomains || eventDomains.length === 0) {
    return 1.0;
  }
  const eventCM = eventDomains.reduce((sum, domain) => sum + (coherenceMemory[domain] || 0), 0);
  const averageCM = eventCM / eventDomains.length;
  return 1 + averageCM; // Simple positive bias
};

export function computeEventAffordances(gradientVector, pressure, projectionMode, coherenceMemory) {
  const desiredDelta = computeDesiredCoherence(gradientVector);

  return eventPool
    .map(e => ({
      ...e,
      resonance: dot(desiredDelta, e.coherenceVector)
        * pressureWeight(pressure)
        * biasFromCM(e.domain, coherenceMemory)
    }))
    .filter(e => e.resonance > THRESHOLD)
    .sort((a, b) => b.resonance - a.resonance)
    .slice(0, 5)
    .map(e => ({
        ...e,
        description: e.descriptions[projectionMode] || e.descriptions.abstract
    }));
}
